import { render } from "./TissuTypeForm.vue?vue&type=template&id=8b02ee98"
import script from "./TissuTypeForm.vue?vue&type=script&lang=js"
export * from "./TissuTypeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__